'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation for the three-finger touch gesture.
 */
export function TouchGesturesTwoFingerAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import(
      '../raw-json/functional-assessment/gestures/multitouch-two-fingers.json'
    );

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="TouchGesturesTwoFingerAnimation"
    />
  );
}
